import * as React from 'react';
import { useMsgText } from '../localization/hooks';
import { Str } from '../localization/translationKeys';
import SurveyHeader from '../project/survey/SurveyHeader';
import Msg from '../localization/Msg';
import { onMobileDevice } from '../globalStyle/mediaQueries';
import { css } from '@emotion/core';
import { PLAIN_BLUE_LINKS } from '../forms/styles/links';
import LocalDiv from '../localization/LocalDiv';
import PortalAutoLayout from '../layout/PortalAutoLayout';


const styles = {
  content: css`
    margin-top: 57px;
    ${onMobileDevice} {
      margin-top: 20px;
    }
  `,
  header: css`
    ${onMobileDevice} {
      margin-top: 37px;
    }  
  `,
  labels:  {
    title: css`
      font-weight: bold;
    `,
    value: css`
      margin-bottom: 20px;
    `,
  },
};


type Props = {
  className?: string;
};


/**
 * CustomerService: a component that shows customer service information
 *
 * PureComponent: true
 * Redux Connected: false
 */
const CustomerService: React.FC<Props> = props => {
  const pageTitle = useMsgText(Str.CustomerService);

  return (
    <PortalAutoLayout className={props.className}>
      <SurveyHeader title={`/ ${pageTitle}`} deadline={undefined} css={styles.header} />
      <LocalDiv css={styles.content}>
        <Msg str={Str.Phone} css={styles.labels.title} />
        <div css={styles.labels.value}>
          <Msg str={Str.CustomerServicePhone} />
        </div>
        <Msg str={Str.Online} css={styles.labels.title} />
        <div css={styles.labels.value}>
          <Msg defaultMsg='' str={Str.CustomerServiceSupportLink} css={PLAIN_BLUE_LINKS} />
        </div>
        <Msg str={Str.Hours} css={styles.labels.title} />
        <div css={styles.labels.value}>
          <Msg str={Str.CustomerServiceHours} />
        </div>
      </LocalDiv>
    </PortalAutoLayout>
  );
};

export default CustomerService;
